import {createFeatureSelector, createSelector} from "@ngrx/store";
import {documentFeatureKey, DocumentState} from "../reducers/document.reducer";

const documentFeatureState = createFeatureSelector<DocumentState>(documentFeatureKey);

export const getDocument = createSelector(
  documentFeatureState,
  state => state.document ?? null
);
